export const formatURL = (url: string) => {
  const { origin, pathname, search } = new URL(url);
  return `${origin}${pathname}${search}`;
};

export const paymentMethods = {
  CASH: 'Pago en efectivo',
  CASH_ON_DELIVERY: 'Pago en caja',
};
